import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonConfig, FireEvent, KeyValue } from '../../../global';
import { NgFor } from '@angular/common';
import { AccessDirective } from '../../directives/has-access.directive';
import { ButtonComponent } from '../buttons/button/button.component';

@Component({
    selector: 'slm-bottom-bar',
    templateUrl: './bottom-bar.component.html',
    styleUrls: ['./bottom-bar.component.scss'],
    imports: [NgFor, AccessDirective, ButtonComponent]
})
export class BottomBarComponent {
  public rightButtons: Array<ButtonConfig> = [];
  public leftButtons: Array<ButtonConfig> = [];

  @Input('buttons')
  public set setButtons(buttons: Array<ButtonConfig>) {
    this.rightButtons = (buttons || []).filter(
      (button) => !button.align || button.align === 'right'
    );
    this.leftButtons = (buttons || []).filter(
      (button) => button.align === 'left'
    );
  }

  @Input() public flexible = false;
  @Input() public disableButtons: Array<KeyValue> = [];
  @Output() public fireEvent = new EventEmitter<FireEvent>();

  public isDisabled(action: string) {
    return !!(this.disableButtons || []).find(
      (value) => value.key === action && !!value.value
    );
  }
}
